import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../types/store';
import { closeAlertDialog } from '../../../store/Reducers/AlertDialogSlice';

export const AlertDialog = () => {
  const dispatch = useDispatch();
  const { open, title, description, confirmText, cancelText, onConfirm, onCancel } = useSelector(
    (state: IRootState) => state.alertDialog,
  );

  const handleClose = () => {
    dispatch(closeAlertDialog());
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    dispatch(closeAlertDialog());
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    dispatch(closeAlertDialog());
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          {cancelText}
        </Button>
        <Button variant="contained" onClick={handleConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
